// extracted by mini-css-extract-plugin
export default {"header":"HeaderMenu_header__teijy","github-link":"HeaderMenu_github-link__T7Um2","github-link-after":"HeaderMenu_github-link-after__y8m6-"};